import React, { useState, useEffect } from 'react';
import { Container, Button, TextField ,AppBar,Tooltip, Modal, Box, Toolbar,Typography,Paper} from '@mui/material';
import { useParams } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { Navigate, useNavigate } from 'react-router-dom';

function EditClassType() {
  let navigate = useNavigate();
  const [classTypeData, setClassTypeData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [classType, setClassType] = useState('');
  const [loadingBarProgress,setLoadingBarProgress] = useState('');
  const { classTypeId } = useParams();

  useEffect(() => {
    fetchClassTypeData();
  }, []);

  const fetchClassTypeData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/ClassType/GetClassType`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const classTypes = await response.json();
        setLoadingBarProgress(100);
        setClassTypeData(classTypes);
        
        const foundClassType = classTypes.find(item => item.classTypeId === parseInt(classTypeId));
        if (foundClassType) {
          setClassType(foundClassType.classType);
        } else {
          console.error('Class type not found');
        }
      } else {
        setLoadingBarProgress(0);
        console.error('Error fetching class type data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const handleUpdate = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/ClassType/Id?Id=${classTypeId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          classType: classType,
        }),
      });

      const data = await response.json();
      setLoadingBarProgress(100);

      const message = (data && (data.msg || data.message)) || 'Class Type has been updated successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  return (
      <Container mt={4}>
             <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
                               <Toolbar>
                                   <Typography variant="h4" component="div" style={{fontWeight:'bold'}}>
                                       Add Class Type
                                   </Typography>
                               </Toolbar>
                           </AppBar>
                           <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
             <div>
               <TextField
                 label="Class Type"
                 variant="outlined"
                 fullWidth
                 value={classType}
                 onChange={(e) => setClassType(e.target.value)}
                 sx={{ mb: 3 }}
               />
               <Tooltip title={!classType && "Enter Class Type"} arrow>
               <span><Button
                 variant="contained"
                 color="primary"
                 onClick={handleUpdate}
                 sx={{ mr: 2 }}
                 disabled={!classType}
               >
                 SAVE
               </Button></span></Tooltip>
               <Button
                 variant="contained"
                 color="error"
                 onClick={()=>{navigate(-1)}}
               >
                 CANCEL
               </Button>
             </div>
             </Paper>
       
             <Modal
         open={modalOpen}
         onClose={() => setModalOpen(false)}
         aria-labelledby="response-modal-title"
         aria-describedby="response-modal-description"
       >
         <Box
           sx={{
             position: 'absolute',
             top: '50%',
             left: '50%',
             transform: 'translate(-50%, -50%)',
             width: 400,
             bgcolor: 'background.paper',
             borderRadius: 2,
             boxShadow: 24,
             overflow: 'hidden',
           }}
         >
           <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
             <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
               {modalType === 'error' ? 'Error ❌' : 'Class Type Updated ✅'}
             </Typography>
           </Box>
       
           <Box sx={{ padding: '20px' }}>
             <Typography id="response-modal-description" sx={{ mb: 2 }}>
               {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'Class Type has been updated successfully.')}
             </Typography>
       
             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
               <Button
                 onClick={() => {
                   setModalOpen(false);
                   if (modalType !== 'error') navigate(-1);
                 }}
                 variant="contained"
                 color="primary"
               >
                 OK
               </Button>
             </Box>
           </Box>
         </Box>
       </Modal>
       
           </Container>
  );
}

export default EditClassType;
